import * as types from './mutation-types.js'
// import * as globalTypes from '../../mutation-types'
import moment from "moment";

export const setInfoLog = ({ commit }, log) => {
    // console.log('set info log is running')
    log = logFormat('info'.fontcolor('green'), log, moment().format())
    // console.log(log)
    commit(types.SET_LOGS, log + "<br />")
}

export const setWarnLog = ({ commit }, log) => {
    log = logFormat('warn'.fontcolor('#FFD700'), log, moment().format())
    // console.log(log)
    commit(types.SET_LOGS, log + '<br />')
}

export const setErrorLog = ({ commit }, log) => {
    log = logFormat('error'.fontcolor('red'), log, moment().format())
    // console.log(log + '<br />')
    commit(types.SET_LOGS, log + '<br />')
}

export const clearLogs = ({ commit }) => {
    commit(types.CLEAR_LOGS);
}

const logFormat = (level, message, timestamp) => {
    return `${timestamp} ${level}: ${message}`
}


// WEBPACK FOOTER //
// ./src/store/modules/logger/actions.js